import * as React from "react";
import logo from '../../../resource/img/nembo.png';
import Wait from "../popups/wait";
import TransactionPopup from "../popups/transacrions/transaction_popup";
import Dashboard from "./dashboard";
import PopDetail from "../popups/popdetail";
import MobileTable from "../tables/tb_mobile";
import MobilePopup from "../popups/mobile/mobile_popup";
import ProjectPane from "../pane/mobile/project_pane";
import MobileReadService from "../../services/mobile/mobile_read";
import {PasswordResetRequest} from "../popups/uma/password-reset";

export default class MobileLayout extends React.Component{

    static current_menu = 0
    static self = null
    constructor(props) {
        super(props);

        this.state = {
            menu_project_output:[],//"CCRO","Residental License","CRO","Rent Blocks","Demand Note"
            menu:[{title:'',icon:''}],
            is_admin: this.props.is_super_user?'inherit':'none',

            left_menu:[
                {title:'Common', access:true, submenu:[
                    {title:'Active Projects',id:1},
                    {title:'Not Active Projects',id:0},
                    ]},
                {title:'By Task', access:true, submenu:[{title:'Pending Request',pane:'Loading...'}]},
                {title:'By Projects', access:true, submenu:[{title:'First Parcel Registration',pane:'Loading...'}]},
            ],
            i:0,
            j:0,
        }

        MobileLayout.self = this
        this.showAddSubmenuAt = this.showAddSubmenuAt.bind(this)
        this.showLeftMenuAt = this.showLeftMenuAt.bind(this)
        this.setMenuAt = this.setMenuAt.bind(this)



        this.loadProjectOutputs = this.loadProjectOutputs.bind(this)

    }

    componentDidMount() {
        try {
            this.loadProjectOutputs()

        }catch (e){
            console.log(e)
        }
    }

    showAddSubmenuAt(i,transactions){
        this.setState({menu:transactions})
        document.getElementById('pop-new').style.display ='inherit'
        MobileLayout.current_menu = i
    }

    setMenuAt(trans){

        TransactionPopup.show(trans)

    }

    showLeftMenuAt(i,j,submenu,title=''){
        this.setState({
            i:i,
            j:j,
        })

        this.state.menu.forEach((d,ii)=>{ if(ii!==i){document.getElementById('sub-menu-'+ii).style.display = 'none';}});

        let div_submenu = document.getElementById('sub-menu-'+i);

        if(!submenu){
            div_submenu.style.display = div_submenu.style.display==='inherit'?'none':'inherit';
        }else{
            MobileTable.loadData('all','all',0,title)
        }


    }

    showSystemAdmin(){

    }

    render() {
        return(<div className={'base-container'} id={'base-container'}>

            <div className={'col col-sm-12 base-toolbar'}>

                <div className={'col col-sm-2'} style={{float:'left'}}>
                    <span className={'fa fa-navicon'} style={{marginRight:'16px',fontSize:'20px'}}/>
                    <img src={logo} alt={'logo'} style={{height:'4vh',marginRight:'16px',marginTop:'-1.5vh'}}/>
                    <span style={{fontFamily:'oxygen-bold',fontSize:'20px'}}>ILMIS</span>

                </div>

                {<div id={'btn-new'} style={{float:'left',padding:'0px 8px'}} onClick={()=>this.showAddSubmenuAt(0,[])}>
                    <span className={'fa fa-plus'} style={{fontSize:'18px',marginRight:'8px'}}/>
                    <b>New Project</b>
                </div>}



                <div style={{float:'right'}}>
                     <span style={{cursor:"pointer"}}
                           onClick={sessionStorage.getItem('username') !== null?()=>PopDetail.show("Password Reset Request",<PasswordResetRequest user={sessionStorage.getItem('username')}/>,50):()=>{}}>{sessionStorage.getItem('username')}</span>
                    <span onClick={()=>Dashboard.logout()} className={'fa fa-power-off'}
                          style={{fontSize:'18px',cursor:'pointer',marginLeft:'16px'}}/>
                    {/*<span>{sessionStorage.getItem('username')}</span>
                    <span onClick={()=>Dashboard.logout()} className={'fa fa-power-off'}
                          style={{fontSize:'18px',cursor:'pointer',marginLeft:'16px'}}/>*/}
                </div>

                <div id={'btn-admin'} style={{float:'right',display:this.state.is_admin,padding:'0px 24px'}} onClick={()=>this.showSystemAdmin()}>
                    <span className={'fa fa-cog'} style={{fontSize:'18px',marginRight:'8px'}}/>
                    <b>System Admin</b>
                </div>

            </div>
            {/*------------------------------------------------------*/}

            <div className={'col col-sm-2 base-body-left'}>
                {
                    this.state.left_menu.map((d,i)=>{

                        return(<div key={'left-menu-'+i} style={{display:d.access?'inherit':'none'}}>

                                <div key={'menu-'+i} className={'btn-left-menu'} onClick={()=>this.showLeftMenuAt(i,0,false)}>

                                    <b>{d.title}</b>
                                </div>

                                <div id={'sub-menu-' + i} style={{display: i===0?'inherit':'none',padding:'8px',margin:'2px 0',backgroundColor:'#fff'}}>
                                    {d.submenu.map((s, j) => {
                                        return (<div key={'sub-menu-' + j} className={'sub-menu'} onClick={()=>this.showLeftMenuAt(i,j,true,s.title)}>
                                            <span className={'fa fa-angle-double-right'} style={{marginRight:'8px'}}/>
                                            <span>{s.title} </span>
                                            {/**/}
                                        </div>)
                                    })}
                                </div>
                        </div>)
                    })
                }
            </div>

            {/*------------------------------------------------------*/}

            <div className={'col col-sm-10 base-body-right'} >
                <MobileTable is_super_user={this.props.is_super_user}/>
            </div>


            {/*------------------------------------------------------*/}


            <div onMouseLeave={()=>document.getElementById('pop-new').style.display='none'}
                 className={'col col-sm-4'} style={{position:'absolute',display:'none',minWidth:'400px',textAlign:'left',left:'17vw',top:'6vh',padding:0}} id={'pop-new'}>

                <div className={'col col-sm-6'} style={{background:'#f7f7f7',boxShadow:'0 0 10px #888',float:'left',padding:0}}>
                    {
                        this.state.menu_project_output.map((d,i)=>{
                            return(<div key={i} className={'btn-left-menu'} id={'tp-mn-'+i} onClick={()=>this.createNewProjectAt(i,d)}>
                                <b>{d.name}</b>
                            </div>)
                        })
                    }
                </div>


            </div>



            {/***** Waiting Pane*****/}

            <MobilePopup/>




        </div>)
    }

    static show(){ document.getElementById('base-container').style.display='inherit' }








    /*------------------ New Work -----------------*/
    loadProjectOutputs() {
        try {
            Wait.show("Loading Projects...")
            MobileReadService.readTranslateByCategorySubCategory("mobile","output").then(d=>{
                Wait.dismiss()
                try {
                    this.setState({menu_project_output:d.data.results})
                }catch (e){
                    console.log(e)
                }
            })
        }catch (e) {
            console.log(e)
        }
    }

    createNewProjectAt(psn,output) {
        MobilePopup.show({
            outputId:output.id,
            outputName:output.name,
            projectName:'New '+output.name,
            is_new:true,
        },<ProjectPane
            title={output.name}
            key={new Date().getMilliseconds()}/>)

    }


    static isAdmin(){
        return MobileLayout.self.props.is_super_user
    }
}

